export function getIdsFilter(ids: string | string[] | null = null): any {
  ids = ids || [];
  if (typeof ids === 'string') {
    ids = [ids];
  }

  let filter = null;
  if (ids.length > 0 && ids.length < 100) {
    filter = {'Id': {in: {type: 'guid', value: ids}}};
  }
  return filter;
}

export function getIdsInArrayWrapper(ids: string | string[] | null = null) {
  ids ??= [];
  if (typeof ids === 'string') {
    ids = [ids];
  }
  if (ids.length > 0 && ids.length < 100) {
    return {items: ids};
  }
  return {items: []};
}

